import { render, staticRenderFns } from "./AgTableBtnCell.vue?vue&type=template&id=19830683&scoped=true&"
import script from "./AgTableBtnCell.vue?vue&type=script&lang=js&"
export * from "./AgTableBtnCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19830683",
  null
  
)

export default component.exports